// Lazily load videos as the page is scrolled
export default function lazyVideo() {
  document.addEventListener("DOMContentLoaded", function() {
    let lazyVideos = document.querySelector("video") ? [].slice.call(document.querySelectorAll("video[data-lazy]")) : null;

    if (lazyVideos) {
      if ("IntersectionObserver" in window) {
        let options = {
          threshold: 0.65,
        };

        let lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(video) {
            if (video.isIntersecting) {
              video.target.src = video.target.dataset.src;
              video.target.load();
              video.target.removeAttribute("data-lazy");
              lazyVideoObserver.unobserve(video.target);
            }
          });
        }, options);

        lazyVideos.forEach(function(video) {
          lazyVideoObserver.observe(video);
        });
      }
    }
  });
}
